import styled from "styled-components";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";
import CustomButton from "../CustomButton/CustomButton";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  background-color: white;
  padding: 2em;
  margin: 3em;
  border-radius: 15px;
  text-align: left;

  .headerMessage {
    font-weight: 700;
    font-size: 20px;
    color: ${theme.colors.primaryStrong2X};
  }

  .subHeaderMessage {
    margin-top: 20px;
    font-weight: 500;
    font-size: 17px;
    color: ${theme.colors.primaryStrong};
  }

  .buttonsContainer {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    gap: 10px;
    margin-top: 20px;
  }
`;

const CustomModal = ({
  headerMessage,
  subHeaderMessage,
  primaryButtonText,
  onClose,
  onClick,
}) => {
  return (
    <Backdrop>
      <BodyWrapper>
        <ModalBody>
          <div className="headerMessage">{headerMessage}</div>
          <div className="subHeaderMessage">{subHeaderMessage}</div>
          <div className="buttonsContainer">
            <CustomButton
              text="Cancel"
              buttonType="secondary"
              onClick={onClose}
            ></CustomButton>

            <CustomButton
              text={primaryButtonText}
              buttonType="primary"
              onClick={onClick}
            ></CustomButton>
          </div>
        </ModalBody>
      </BodyWrapper>
    </Backdrop>
  );
};

export default CustomModal;
